import { getRatio } from "./getRatio";
export const getRatioAsString = (width, height, precision = 0) => {
    return Object
        .values(getRatio(width, height, precision))
        .join(':');
};
